<app-header-page>
    <h1>{{ 'HEADERS.CATALOGS' | translate }}</h1>
</app-header-page>

<div class="row">
    <div class="col-4">
        <div class="catalog-container">

            <div (click)="modalService.openTemplateModal(createCatalogModal)"
                 class="catalog-item item-head flex-display justify-content-center btn-success"
                 data-action="openCreateCatalogModal"
            >
                <i class="bi bi-plus me-1"></i>
                <span>{{ 'CATALOGS.BUTTONS.CREATE' | translate }}</span>
            </div>

            <div *ngFor="let catalog of allCatalogs" class="catalog-item">
                <div (click)="selectCatalog(catalog)"
                     [class.error]="!catalog.items.length"
                     [class.selected]="selectedCatalog && (catalog.id === selectedCatalog.id)"
                     [ngbTooltip]="catalog.items.length ? '' : ( 'CATALOGS.TEXT.EMPTY' | translate )"
                     class="catalog-item item-head flex-display justify-content-between"
                >
                    <div>
                        <i class="bi bi-justify me-5px"
                           ngbTooltip="{{ 'CATALOGS.TEXT.CATALOG' | translate }}"
                        ></i>
                        <span>{{ catalog.title }}</span>
                    </div>
                    <div>
                        <i (click)="openEditModal(true, catalog, catalogInformation, $event)"
                           class="bi bi-info-circle me-5px pointer"
                           ngbTooltip="{{ 'CATALOGS.BUTTONS.MORE' | translate }}"
                        ></i>
                        <i (click)="openEditModal(true, catalog, editCatalogModal, $event)"
                           class="bi bi-pen me-5px pointer"
                           ngbTooltip="{{ 'CATALOGS.BUTTONS.EDIT' | translate }}"
                        ></i>
                        <i (click)="deleteCatalog(catalog, $event)"
                           class="bi bi-trash text-danger me-5px pointer"
                           ngbTooltip="{{ 'CATALOGS.BUTTONS.DELETE' | translate }}"
                        ></i>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="col-4">
        <div *ngIf="selectedCatalog" class="items-container mt-2">
            <h2 class="ms-3">{{ 'CATALOGS.TEXT.CATALOG' | translate }}: {{ selectedCatalog.title }}</h2>
            <div (click)="openEditModal(true, selectedCatalog, createCatalogItemModal, $event)"
                 class="catalog-items flex-display justify-content-between pointer"
            >
                <div style="max-width: 85%">
                    <span><i class="bi bi-plus me-5px"></i>{{ 'CATALOGS.BUTTONS.ADD_ELEM' | translate }}</span>
                </div>
            </div>

            <div *ngFor="let item of selectedCatalog.items"
                 class="catalog-items flex-display justify-content-between"
            >
                <div style="max-width: 85%">
                    <i class="bi bi-dot me-5px"></i>
                    <span>
					{{ item.items_text }}
				</span>
                </div>
                <div>
                    <i (click)="openEditModal(false, item, editCatalogItemModal, $event)"
                       class="bi bi-pen me-5px pointer"
                       ngbTooltip="{{ 'CATALOGS.BUTTONS.EDIT_ELEM' | translate }}"
                    ></i>
                    <i (click)="deleteCatalogItem(item)"
                       class="bi bi-trash text-danger me-5px pointer"
                       ngbTooltip="{{ 'CATALOGS.BUTTONS.DELETE_ELEM' | translate }}"
                    ></i>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #createCatalogModal let-modal>
    <app-button-modal-close (closeEmit)="description = null" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.CREATE_CATALOG' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #catalogName class="form-control" id="catalogName">

        <h2 style="margin-top: 15px">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <app-component-ckeditor
                (emitFinish)="description = $event[1]"
                [isShowButtons]="false">
        </app-component-ckeditor>

        <div style="margin-top: 15px">
            <input #isOpen
                   id="is-open"
                   name="is-open"
                   style="width: auto;"
                   type="checkbox"
            >
            <label for="is-open" style="margin-left: 5px;">{{ 'MODALS.FIELDS.ONLY_ADMIN' | translate }}</label>
        </div>

        <button (click)="createCatalog(catalogName.value, isOpen.checked, modal)"
                class="btn btn-success"
                data-action="openCreateCatalogModal"
        >
            <span>{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #editCatalogModal let-modal>
    <app-button-modal-close (closeEmit)="description = null" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.EDIT_CATALOG' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #catalogName
               (change)="manageCatalog.title = catalogName.value"
               [value]="manageCatalog.title"
               class="form-control"
               type="text"
        >

        <h2 style="margin-top: 15px">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <app-component-ckeditor
                (emitFinish)="description = $event[1]"
                [inputData]="manageCatalog.description"
                [isShowButtons]="false"
                placeholder="{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}">
        </app-component-ckeditor>

        <div style="margin-top: 15px">
            <input (change)="manageCatalog.is_open = !manageCatalog.is_open"
                   [checked]="!manageCatalog.is_open"
                   id="selected-catalog-is-open"
                   name="selected-catalog-is-open"
                   style="width: auto;"
                   type="checkbox"
            >
            <label for="selected-catalog-is-open"
                   style="margin-left: 5px;">{{ 'MODALS.FIELDS.ONLY_ADMIN' | translate }}</label>
        </div>

        <button (click)="editCatalog(modal)"
                class="btn btn-success"
                data-action="openCreateCatalogModal"
        >
            <span>{{ 'MODALS.BUTTONS.SAVE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #createCatalogItemModal let-modal>
    <app-button-modal-close (closeEmit)="description = null" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.CREATE_ELEM' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #catalogItemName class="form-control" id="catalogItemName">

        <button (click)="createCatalogItem(catalogItemName.value, modal)"
                class="btn btn-success"
                data-action="openCreateCatalogModal"
                style="margin-top: 15px"
        >
            <span>{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #editCatalogItemModal let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.EDIT_ELEM' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <div>
            <input #itemName
                   (change)="selectedCatalogItem.items_text = itemName.value"
                   [value]="selectedCatalogItem.items_text"
                   class="form-control"
                   type="text"
            >
        </div>
        <button (click)="editCatalogItem(modal)"
                class="btn btn-success"
                data-action="openCreateCatalogModal"
                style="margin-top: 15px"
        >
            <span>{{ 'MODALS.BUTTONS.SAVE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #catalogInformation let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.CATALOG' | translate }} {{ manageCatalog.title }}</h1>
        <strong>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}:</strong>
        <div *ngIf="manageCatalog.description" [innerHTML]="manageCatalog.description"></div>
        <p *ngIf="!manageCatalog.description">{{ 'EMPTY_FIELDS.DESCRIPTION' | translate }}</p>

        <p><strong>{{ 'MODALS.TEXT.ELEM_LENGTH' | translate }}: </strong> {{ manageCatalog.items_count }}</p>
        <p><strong>{{ 'MODALS.TEXT.CREATED' | translate }}:</strong> {{ helper.formatDate(manageCatalog.created_at) }}
        </p>
        <p><strong>{{ 'MODALS.TEXT.UPDATED' | translate }}: </strong> {{ helper.formatDate(manageCatalog.created_at) }}
        </p>
        <p>
            <strong>{{ (!manageCatalog.is_open ? 'MODALS.TEXT.ONLY_ADMIN_CHANGE' : 'MODALS.TEXT.ALL_CHANGE') | translate }}</strong>
        </p>
    </div>
</ng-template>

